/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgStar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M12 1.74a.75.75 0 01.673.418l2.915 5.907 6.52.953a.75.75 0 01.415 1.28l-4.717 4.594 1.113 6.491a.75.75 0 01-1.088.79L12 19.108l-5.83 3.067a.75.75 0 01-1.09-.79l1.114-6.492-4.717-4.595a.75.75 0 01.415-1.28l6.52-.952 2.915-5.907A.75.75 0 0112 1.74zm0 2.444L9.583 9.082a.75.75 0 01-.565.41l-5.407.79 3.912 3.81a.75.75 0 01.216.665l-.923 5.382 4.835-2.543a.75.75 0 01.698 0l4.835 2.543-.923-5.382a.75.75 0 01.216-.664l3.912-3.81-5.407-.79a.75.75 0 01-.564-.411L12 4.184z'
      />
    </svg>
  );
}

export default SvgStar;
